import './ViewDialog.scss';

import dayjs from 'dayjs';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import useAxiosHook from '../../../../../hooks/useAxiosHook';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import { EntityIdRouteParams } from '../../../../../types/routing';
import DialogSpinner from '../../../../Dialogs/DialogSpinner/DialogSpinner';
import { TransportEntitiesType } from '../../TransportEntities.functions';

type Props = {
  isShown: boolean;
  onHide: () => void;
  isEditBtnShown: boolean;
  setIsEditDialog: (isEditDialog: TransportEntitiesType) => void;
};

function ViewDialog({
  isShown,
  onHide,
  isEditBtnShown,
  setIsEditDialog,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const { id } = useParams<EntityIdRouteParams>();
  const isOnMobile = useMediaQuery('(max-width: 768px)');

  const { data: dataTransportEntity, isLoading: isLoadingTransportEntity } =
    useAxiosHook<TransportEntitiesType>(`/v2/transport-entities/${id}`, {
      skipWhen: !isShown && !id,
    });

  const dialogFooter = !isLoadingTransportEntity && (
    <>
      {isEditBtnShown && (
        <Button
          label={t('Edit')}
          className="p-button-text"
          onClick={() => setIsEditDialog(dataTransportEntity!)}
        />
      )}
      <Button label={t('Close')} onClick={() => onHide()} />
    </>
  );

  return (
    <Dialog
      header={
        isLoadingTransportEntity
          ? t('Loading...')
          : t('Preview on transport entity')
      }
      footer={dialogFooter}
      visible={isShown}
      resizable={false}
      onHide={onHide}
      maximizable
      maximized={isOnMobile}
      style={{ width: 580, maxWidth: '100%' }}
      className="transport-entities-view-dialog"
    >
      {isLoadingTransportEntity ? (
        <DialogSpinner />
      ) : (
        <>
          <span className="section-title">{t('General information')}</span>
          <table cellPadding="0" cellSpacing="0">
            <tbody>
              <tr>
                <td>{t('Barcode')}</td>
                <td className="route-name">{dataTransportEntity?.barcode}</td>
              </tr>
              <tr>
                <td>{t('Owner logistic point')}</td>
                <td className="route-name">
                  {dataTransportEntity?.ownerLogisticsPoint?.name}
                </td>
              </tr>
              <tr>
                <td>{t('Current logistic point')}</td>
                <td className="route-name">
                  {dataTransportEntity?.currentLogisticsPoint?.name ??
                    t('transport in progress')}
                </td>
              </tr>
              <tr>
                <td>{t('Created at')}</td>
                <td className="route-name">
                  {dataTransportEntity?.createdAt
                    ? dayjs(dataTransportEntity.createdAt).format(
                        'DD MMM YYYY, HH:mm:ss'
                      )
                    : '-'}
                </td>
              </tr>
              <tr>
                <td>{t('Modified at')}</td>
                <td className="route-name">
                  {' '}
                  {dataTransportEntity?.modifiedAt
                    ? dayjs(dataTransportEntity.modifiedAt).format(
                        'DD MMM YYYY, HH:mm:ss'
                      )
                    : '-'}
                </td>
              </tr>
              <tr>
                <td>{t('Volume')}</td>
                <td className="route-name">{dataTransportEntity?.volume}</td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </Dialog>
  );
}

export default ViewDialog;
